import moment from "moment";
import useChecksNoteDialog from "./useChecksNoteDialog"
import { Dialog, Loader, NoData, PhotoSlider } from "@/components";
import { roleName } from "../../const";


const ChecksNoteDialog = ({
  open,
  setOpen
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const {
    isAttachmentsLoading,
    attachmentList,
    title,
    isSliderOpen,
    setIsSliderOpen,
    selectedPhotos,
  } = useChecksNoteDialog();ChecksNoteDialog

  return (
    <>
      <Dialog open={open} setOpen={setOpen} title={title} contentClassName="lg:!w-[600px] lg:!max-w-[600px]">
        <div className="flex flex-col gap-2">
          {
            isAttachmentsLoading ? <Loader /> : !attachmentList?.data?.filter((data: any) => data?.description)?.length ? <NoData /> :
              attachmentList?.data?.filter((data: any) => data?.description)?.map((data: any, index: number) => {
                return (
                  <div key={`safety-note-${index}`} className="text-[14px] font-semibold text-gray-600 flex items-center justify-between">
                    <div>
                      <span className="text-black">{index + 1}. This task is marked as</span> {data?.status} By: {data?.createdByName || ""}({(roleName as any)[data?.createdByRoleName?.toLowerCase()]}) on {moment(data?.createdAt).format('MM-DD-YYYY')} - {data?.description}
                    </div>
                    
                  </div>
                )
              })
          }
        </div>
        <PhotoSlider
          isOpen={isSliderOpen}
          onClose={() => setIsSliderOpen(false)}
          photos={selectedPhotos}
          category="Safety Check Attachments"
          showActions={false}
        />
      </Dialog>
    </>
  )
}

export default ChecksNoteDialog;